var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShardsDashboardsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shards---Dashboard---Overview-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-118.000000, -54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar",
    fill: "#007BFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(118.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9333011,30.314967 L18.0691155,18.8037699 L24.5642017,14.9387788 L28.0175608,19.8727243 L21.9333011,30.314967 Z M19.4087321,32.609151 L12.6663444,21.1801192 L16.4902529,19.8646689 L20.3133559,31.0463992 L19.4087321,32.609151 Z M20.2311906,7.39084904 L23.8488803,13.5991622 L12.1733527,19.8066699 L20.2311906,7.39084904 Z M20,0 C8.95440632,0 0,8.95440632 0,20 C0,31.0455937 8.95440632,40 20,40 C31.0447881,40 39.9991945,31.0455937 39.9991945,20 C39.9991945,8.95440632 31.0447881,0 20,0 L20,0 Z",
    id: "Logo-Icon"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShardsDashboardsLogo);
export default __webpack_public_path__ + "static/media/shards-dashboards-logo.9262a9e47e22c87729762f8b162cbd3d.svg";
export { ForwardRef as ReactComponent };